export default __webpack_public_path__ + "static/media/Mask Group 11-Tata.6b26c4e3.png";